<template>
    <div class="childPageWrap preview">
      <i v-if="isEmptyPage" class="iconfont icon-page"></i>
      <div
        v-else
        class="canvas"
        ref="canvas"
        :style="Object.assign({}, {
          width: getCanvasStyleData.width + 'px',
          height: getCanvasStyleData.height + 'px',
          backgroundSize: `100% 100%`,
          backgroundRepeat: 'no-repeat',
          transformOrigin: '0px 0px'
        }, getCanvasStyleData.backPicSrc ? {
          backgroundImage: `url(${getCanvasStyleData.backPicSrc})`
        } : {
          backgroundColor: getCanvasStyleData.backgroundColor || ''
        })"
      >
        <ComponentWrapper
          v-for="item in useableComponentsData"
          :key="item.id"
          :config="item"
          :currentComps="currentComps"
          :childPageComps="useableComponentsData"
          :allBtnPressMap="isPreview ? allBtnPressMap : {}"
          @changeCurComp="changeCurComp"
          @changePage="changePage"
          @changeBtnPress="changeBtnPress"
        />
      </div>
    </div>
</template>

<script>
import { getPicSrc } from "@/utils/utils";
import ComponentWrapper from "../components/Editor/ComponentWrapper";
import { mapState } from 'vuex';
import eventBus from '@/utils/eventBus';
import { isPageSkeleton, parseCanvasAllData } from '@/utils/canvasPageLoader';

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    isPreview: Boolean,
    currentComps: {
      type: String,
      require: false
    },
    allBtnPressMap: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      isEmptyPage: true,
      childComponent: []
    };
  },
  components: {
    ComponentWrapper
  },
  computed: {
    ...mapState(["canvasAllData", "canvasLazyLoad", "canvasLoadedPageIds"]),
    getCanvasStyleData() {
      const { backPicSrc, backgroundColor, pageWidth, pageHeight } = this.childComponent[0]?.style;
      return {
        width: pageWidth,
        height: pageHeight,
        backPicSrc: getPicSrc(backPicSrc),
        backgroundColor: backgroundColor
      };
    },
    useableComponentsData() {
      return this.childComponent.filter((c) => c.id != "Back");
    }
  },
  watch: {
    'element.style.bindPage': {
      handler: function(val) {
        this.updateView();
      },
      deep: true,
      immediate: true
    },
    canvasAllData() {
      this.applyBoundPageData();
    },
    canvasLoadedPageIds: {
      handler() {
        this.applyBoundPageData();
      },
      deep: true
    }
  },
  methods: {
    updateView() {
      if (!this.element.style.bindPage) {
        this.isEmptyPage = true;
        return;
      }
      var bindPageKey = this.element.style.bindPage.value;
      const data = parseCanvasAllData(this.canvasAllData);
      const pageArr = data[bindPageKey] || data[String(bindPageKey)];
      if (
        this.canvasLazyLoad &&
        (!this.canvasLoadedPageIds[String(bindPageKey)] || isPageSkeleton(pageArr))
      ) {
        eventBus.$emit("ensureCanvasPages", {
          pageIds: [bindPageKey],
          done: () => this.applyBoundPageData(),
        });
        return;
      }
      this.applyBoundPageData();
    },
    applyBoundPageData() {
      // 根据已绑定页面去更新当前组件的值
      if (this.element.style.bindPage) {
        // 有值说明已绑定
        var bindPageKey = this.element.style.bindPage.value;
        const data = parseCanvasAllData(this.canvasAllData);
        const pageArr = data[bindPageKey] || data[String(bindPageKey)];
        if (pageArr) {
          var backData = pageArr.find((a) => a.id === 'Back');
          if (!backData || !backData.style) {
            this.isEmptyPage = true;
            return;
          }
          if (pageArr.length > 1 || backData.style.backgroundColor || backData.style.backPicSrc) {
            // 有组件、有背景颜色、背景图片，三种只要有其一，则认为不为空
            // 设置宽高
            this.element.style.width = backData.style.pageWidth;
            this.element.style.height = backData.style.pageHeight;
            this.childComponent = pageArr;
            this.isEmptyPage = false;
            return;
          }
        }
      }
      this.isEmptyPage = true;
    },
    changeCurComp(val) {
      if (!this.isPreview) return;
      this.$emit("changeCurComp", val);
    },
    changePage(val) {
      if (!this.isPreview) return;
      this.$emit("changePage", val);
    },
    changeBtnPress(val) {
      if (!this.isPreview) return;
      this.$emit("changeBtnPress", val);
    }
  }
}
</script>
<style lang="scss" scoped>
.childPageWrap {
  width: 100%;
  height: 100%;
  user-select: none;
  display: table;
  i {
    font-size: inherit;
  }
}
</style>